import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkRestoreTrigger, IClientDetailsStore, IClientDetailsActions } from '../types';

const onRestoreTrigger: IThunkRestoreTrigger = thunk(
  async ({ setClientDetails }: Actions<IClientDetailsActions>, payload, { getState }) => {
    const localState = getState() as IClientDetailsStore;

    await api.clientDetails.restoreClientTrigger(payload);

    const triggers = localState.triggers.map(item =>
      item.id !== Number(payload.id) ? item : { ...item, isArchived: false },
    );

    setClientDetails({ triggers });
  },
);

export default onRestoreTrigger;
